import classNames from 'classnames';

import { Space } from '@sravni/react-design-system/lib/Space';

import pixelStyles from '@src/components/Pixel/styles.module.scss';
import { open } from '@src/helpers/navigationHelper';
import { useBrandingContent } from '@src/reducers/branding';
import { isServer } from '@src/utils';
import { ClientOnly } from 'shared/ui/ClientOnly/ClientOnly';

import { SponsoredMenu } from '../SponsoredMenu/SponsoredMenu';

import { ADENGI_COMPANY_NAME } from './ADengiBanner.config';
import styles from './ADengiBanner.module.scss';
import { ADengiDisclaimer } from './components/ADengiDisclaimer';

interface Props {
  isShowDisplayPixel: boolean;
  bannerVariant?: 'default' | 'entryPoint';
}

export function ADengiBanner({ isShowDisplayPixel, bannerVariant = 'default' }: Props) {
  const branding = useBrandingContent();
  const handleClick = () => {
    open({ href: branding?.analytics?.click, features: 'noopener', target: '_blank' });
  };
  const title = branding?.sponsor?.popover?.title || ADENGI_COMPANY_NAME;
  const isEntryPoint = bannerVariant === 'entryPoint';

  return (
    <>
      <div
        className={classNames(styles.advertising, 'desktop:hidden', { [styles.entryPointAdvertising]: isEntryPoint })}
      >
        <SponsoredMenu company={title} />
      </div>
      <div className={classNames(styles.container, { [styles.entryPointContainer]: isEntryPoint })}>
        <div onClick={handleClick}>
          <Space className={classNames(styles.logoContainer, { [styles.entryPointLogoContainer]: isEntryPoint })}>
            <img alt="Лого" {...branding.logo} className={styles.logo} />
          </Space>
          <Space
            direction="column"
            align="center"
            className={classNames({ [styles.entryPointImageContainer]: isEntryPoint })}
          >
            <img alt="Лого" {...branding.image} className={classNames({ [styles.entryPointImage]: isEntryPoint })} />
          </Space>
          {!isEntryPoint && <ADengiDisclaimer heading={branding?.sponsor?.title} />}
        </div>
        <ClientOnly>
          {!isServer && isShowDisplayPixel && branding?.analytics?.display && (
            <img alt="" className={pixelStyles.pixel} src={branding?.analytics?.display} />
          )}
        </ClientOnly>

        <div className={classNames(styles.advertising, 'mobile:hidden')}>
          <SponsoredMenu company={title} />
        </div>
      </div>
    </>
  );
}

ADengiBanner.displayName = '';
